/**
 * VConsole 静态默认配置（无 window / import.meta），供 VConsoleManager 与 Vite html 插件内联脚本共用。
 */

export const VCONSOLE_ALL_PLUGINS = ["network", "element", "storage", "system"] as const;

export type VConsoleDefaultPlugin = (typeof VCONSOLE_ALL_PLUGINS)[number];

/** 与 parse 逻辑一致：无 URL/localStorage 时的默认 max */
export const VCONSOLE_DEFAULT_MAX_LOG = 3000;

export const VCONSOLE_DEFAULT_THEME = "light" as const;

/** 首次实例化用的可序列化默认项（运行时会被 URL / localStorage 覆盖） */
export const VCONSOLE_DEFAULT_STATIC_OPTIONS = {
  theme: VCONSOLE_DEFAULT_THEME,
  defaultPlugins: [...VCONSOLE_ALL_PLUGINS] as VConsoleDefaultPlugin[],
  maxLogNumber: VCONSOLE_DEFAULT_MAX_LOG,
} as const;

export interface VConsoleSerializableConfig {
  theme?: "light" | "dark";
  defaultPlugins?: VConsoleDefaultPlugin[];
  maxLogNumber?: number;
}
